import { render, staticRenderFns } from "./memberShip.vue?vue&type=template&id=537b34bc&scoped=true&"
import script from "./memberShip.vue?vue&type=script&lang=js&"
export * from "./memberShip.vue?vue&type=script&lang=js&"
import style0 from "./memberShip.vue?vue&type=style&index=0&id=537b34bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537b34bc",
  null
  
)

export default component.exports